<script>
  import Download from "$components/Download/Download.svelte";
  import { LogoUrbanWide } from "@urbaninstitute/dataviz-components";
  /** @typedef {import("svelte").Snippet} Snippet */

  /** @typedef {Object} Props
   * @property {Snippet} title
   * @property {Snippet} description
   * @property {Snippet} children
   * @property {Snippet} source
   * @property {Snippet} notes
   * @property {string} downloadFilename
   * @property {string} downloadLabel
   */

  /** @type {Props} */
  let { title, description, children, source, notes, downloadFilename, downloadLabel } = $props();
</script>

{#snippet vizBody(isDownload)}
  <div class="chart-container">
    <div class="chart-text">
      {@render title?.()}
      {@render description?.()}
    </div>
    {@render children?.(isDownload)}
    {#if isDownload}
      <div class="chart-text">
        <div class="logo-container">
          <LogoUrbanWide width={175} />
        </div>
        {@render source?.()}
        {@render notes?.()}
      </div>
    {/if}
  </div>
{/snippet}
<div class="viz-wrapper">
  {@render vizBody(false)}
  <Download filename={downloadFilename} label={downloadLabel}>
    {@render vizBody(true)}
  </Download>
</div>

<style>
  .chart-container {
    margin-bottom: var(--spacing-8);
  }
  .logo-container {
    display: flex;
    justify-content: flex-end;
    margin-top: var(--spacing-4);
  }
  .chart-text:first-of-type {
    margin-bottom: var(--spacing-8);
  }
</style>
